<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-danger-drive-rule-list [listType]="DtgListType.list"></dtg-manage-danger-drive-rule-list>
    </div>
</div>